import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

// DEV-ONLY form-rule debug. Delete this file, withFormRuleDebugReducer and
// withFormRuleDebugEventHandlers to remove the form-rule debug UI.
export const formRuleDebugEvents = eventGroup({
  source: 'FormRuleDebug',
  events: {
    toggleFormDebugMode: type<void>(),
    // Cycles the admin override: db -> internal_admin -> admin -> none -> db.
    cycleAdminOverride: type<void>(),
    // null uses the vessel's own list. A list is the merge that the debug UI
    // asked the server for.
    setTemplateOverride: type<string[] | null>(),
    // Asks the server for every template name it holds.
    loadTemplateNames: type<void>(),
    gotTemplateNames: type<string[]>(),
    // Asks the server to merge the names in order over 'base'. On success the
    // form applies the merge and the store holds the names as the override.
    applyTemplateOverride: type<{ names: string[]; vesselId: string; applyVesselOverride: boolean }>(),
  },
});
